<template>
    <div class="lesson-preparation">
        <h3 class="title">Bijlagen</h3>
        <ul class="attachments-list">
            <li
                class="attachment-item"
                v-for="file in filesIn"
                :key="file.id">
                <a
                    class="lesson-attachment"
                    :href="file.path"
                    target="_blank">
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'design-2021-lesson-manual-lesson-attachments-component',
};
</script>

<style scoped lang="scss"></style>
